package modysy.menu

import modysy.InputHandler
import modysy.gamestate.{GameState, GameStateManager}
import modysy.view.Color
import org.scalajs.dom
import org.scalajs.dom.ext.KeyCode

class PauseMenu(
    stateManager: GameStateManager,
    inputs: InputHandler,
    width: Int,
    height: Int
) extends AbstractMenu(inputs, width, height) {

  private val buttonDistance = 0.095f
  private val buttonStart = 0.55f

  {
    val resumeButton = new TextButton(
      width * 0.5,
      buttonStart * height,
      "Resume Game"
    )
    resumeButton.fontSize = Math.round(height / 12)
    resumeButton.colorSelected = Color.Green

    resumeButton.action = () => {
      stateManager.resumeGame()
    }

    val replayButton = new TextButton(
      width * 0.5,
      (buttonStart + buttonDistance) * height,
      "Replay Level"
    )
    replayButton.fontSize = Math.round(height / 12)
    replayButton.colorSelected = Color.Yellow

    replayButton.action = () => {
      stateManager.retryLevel()
    }

    val exitButton = new TextButton(
      width * 0.5,
      (buttonStart + 2 * buttonDistance) * height,
      "Main Menu"
    )
    exitButton.fontSize = Math.round(height / 12)

    exitButton.action = () => {
      stateManager.exitGame()
    }

    buttons = resumeButton :: replayButton :: exitButton :: buttons
    buttons.foreach(button => {
      val tmp = button.isEnabled
      button.isEnabled = () => {
        tmp() && (stateManager.gameState == GameState.ingamePaused)
      }
    })
    buttons.foreach(button => {
      button.enableTouch(inputs)
    })
  }

  override def render(ctx: dom.CanvasRenderingContext2D): Unit = {

    ctx.fillStyle = Color.rgba(255, 255, 255, 0.3)
    ctx.fillRect(0, 0, this.width, this.height)

    ctx.font = (height / 12) + "px Arial"
    ctx.fillStyle = Color.White
    ctx.textAlign = "center"
    ctx.textBaseline = "alphabetic"
    ctx.fillText("Pause", this.width / 2, this.height * 0.4 /* / 2*/, 1000)

    super.render(ctx)
  }

  override def update(): Unit = {

    if (inputs.activeKeyEvent(KeyCode.P)) {
      stateManager.resumeGame()
      inputs.clearKeyEvents()
    }
    super.update()
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/2d4fb5cd/0/mtv-pr-2018/modysy-product/src/main/scala/modysy/menu/PauseMenu.scala